import { fetch } from 'http-common';

import { BudgetParams, ProductType } from 'types/api/budgets.type';

type BudgetAmountType = {
  season: string;
  seasonLine: string;
  zone: string;
  genderCode: string;
  budgetNum: string;
  type: string;
};

type BudgetQuantityType = {
  productId: string;
  budgetNum: string;
  quantity: string;
  type: string;
};

class BudgetDataService {
  private http = fetch();

  private ep = '/v1/budget';

  private epCatalogue = '/v1/catalogue/budget';

  public async getAll(season: string, marketingLine: string, zone: string) {
    return this.http.get(`${this.ep}/all/${season}/${marketingLine}/${zone}`);
  }

  public async getBudgetHeader(id: string, zone: string, params: BudgetParams) {
    return this.http.get(`${this.ep}/header/${id}/${zone}`, { params });
  }

  public async getCodes(params: BudgetParams) {
    return this.http.get(`${this.epCatalogue}/all`, { params });
  }

  public async getFabrics(params: BudgetParams) {
    return this.http.get(`${this.epCatalogue}/fabrics`, { params });
  }

  public async getMarketing(params: BudgetParams) {
    return this.http.get(`${this.epCatalogue}/marketings`, { params });
  }

  public async getGenders(params: BudgetParams) {
    return this.http.get(`${this.epCatalogue}/genderQuantity`, { params });
  }

  public async getProductCode(params: BudgetParams, data: string[]) {
    return this.http.post(
      `${this.epCatalogue}/codes`,

      data,

      { params }
    );
  }

  public async getProductFabric(params: BudgetParams, fabric: string) {
    return this.http.get(`${this.epCatalogue}/fabricProducts`, {
      params: {
        ...params,
        fabric,
      },
    });
  }

  public async getProductMarketing(params: BudgetParams, marketing: string) {
    return this.http.get(`${this.epCatalogue}/marketingProducts`, {
      params: {
        ...params,
        marketing,
      },
    });
  }

  public async get(season: string, marketingLine: string) {
    return this.http.get(`${this.ep}/all/${season}/${marketingLine}`);
  }

  public async getProducts(type: ProductType, params: BudgetParams) {
    return this.http.get(`${this.epCatalogue}/${type}`, { params });
  }

  public async getAmountOfLists(params: BudgetAmountType) {
    return this.http.get(`${this.epCatalogue}/itemNum`, { params });
  }

  public async sendBudget(zone: string, budgetNum: string) {
    return this.http.post(`${this.ep}/close/${zone}/${budgetNum}`);
  }

  public async updateQuantity(zone: string, params: BudgetQuantityType) {
    return this.http.post(`${this.ep}/quantity/${zone}`, {}, { params });
  }
}

const budgetDataService = new BudgetDataService();

export { budgetDataService };
